import React from 'react';
import { useCreateReportContext } from './CreateReportContext';
import { QuickCreateWrapper } from './QuickCreateWrapper';

export const QuickCreateForm = () => {
  const { chosenReportType } = useCreateReportContext();

  if (!chosenReportType) {
    return (
      <div className="flex items-center justify-center p-8">
        <p className="text-muted-foreground">
          Please select a report type first.
        </p>
      </div>
    );
  }

  // The QuickCreateWrapper handles its own synchronization with context
  // via useReportFormContextBridge and proper initialization logic
  return <QuickCreateWrapper reportType={chosenReportType} />;
};
